"use client";

import { SessionProvider } from "next-auth/react";

export default function AuthProvider({ children, session }) {
  return <SessionProvider
   session={session}
   refetchOnWindowFocus={false}
      refetchInterval={0}
      refetchWhenOffline={false}
      >{children}</SessionProvider>;
}